import { adapter as cardAdapter } from '@molecules/Card';

export default ({ id, title, description, cards }) => ({
  id,
  title,
  description,
  cards: cards && cards.map((card) => cardAdapter(card)),
});
